import { useSearchParams } from "next/navigation"

import { usePrefilteredJobSearch } from "@/modules/jobSearchPrefiltered/hooks/usePrefilteredJobSearch"
import { usePrefilteredJobSearchParams } from "@/modules/jobSearchPrefiltered/hooks/usePrefilteredJobSearchParams"

export const useJobAdsSearchParams = (forceRawSearchParams?: boolean): URLSearchParams => {
  const readOnlySearchParams = useSearchParams()
  const searchParams = new URLSearchParams(readOnlySearchParams)

  const isPrefilteredJobSearch = usePrefilteredJobSearch()
  const prefilteredSearchParams = usePrefilteredJobSearchParams()

  if (!forceRawSearchParams && isPrefilteredJobSearch) {
    return prefilteredSearchParams
  }

  for (const [key, value] of readOnlySearchParams.entries()) {
    if (!value) {
      // delete method functionaly working but the type not working properly : https://github.com/microsoft/TypeScript-DOM-lib-generator?tab=readme-ov-file#when-the-type-is-missing
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      searchParams.delete(key, value)
    }
  }

  return searchParams
}
